module.exports = "<ng-progress [color]=\"'#0056b3'\"></ng-progress>\n\n<router-outlet></router-outlet>"


//////////////////
// WEBPACK FOOTER
// ./src/app/app.component.html
// module id = ./src/app/app.component.html
// module chunks = main